import { takeLatestApiCall } from 'syft-acp-core/sagas/helpers'

import externalEmployersTypes from './action-types'
import * as api from './api'

export default function* saga() {
  yield takeLatestApiCall(externalEmployersTypes.ENTITIES_FETCH_BEGIN, api.fetchShiftEvents)
}
